import { render, staticRenderFns } from "./TestingFile.vue?vue&type=template&id=6573a284&scoped=true"
import script from "./TestingFile.vue?vue&type=script&lang=js"
export * from "./TestingFile.vue?vue&type=script&lang=js"
import style0 from "./TestingFile.vue?vue&type=style&index=0&id=6573a284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573a284",
  null
  
)

export default component.exports